var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs-items',{attrs:{"value":_vm.tab}},[_vm._l((_vm.tabs),function(ref){
var slot = ref.slot;
return [_c('v-tab-item',{key:slot,attrs:{"value":slot,"transition":"none"}},[_vm._t(slot)],2)]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }